export default {
  'ViewSwitch.Wrapper.Table': ({ }, outlet) => {
    outlet({ view: 'table' });
  },
  'ViewSwitch.Wrapper.List': ({ }, outlet) => {
    outlet({ view: 'list' });
  },
  'ViewSwitch.Wrapper.Grid': ({ }, outlet) => {
    outlet({ view: 'grid' });
  },
}